import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import classNames from 'classnames';

const useStyles = makeStyles(({ palette, spacing }) => ({
  messageHeader: {
    textAlign: 'left',
    fontSize: 20,
    color: palette.text.primary,
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 1.33,
    letterSpacing: 'normal',
  },
  messageHeaderTitle: {
    fontWeight: 'bold',
    marginBottom: spacing(1),
  },
  messageHeaderText: {
    fontWeight: 400,
  },
  messageItem: {
    paddingTop: spacing(4),
  },
}));

const MessageItem = ({ title, message, icon }) => {
  const classes = useStyles();

  const headerTitleClasses = classNames(classes.messageHeaderTitle, classes.messageHeader);
  const headerTextClasses = classNames(classes.messageHeaderText, classes.messageHeader);

  return (
    <Grid className={classes.messageItem} container direction="row" justifyContent="space-between" alignItems="center">
      <Grid item xs={3}>
        <img src={icon} data-src={icon} alt="Message icon" />
      </Grid>
      <Grid item xs={9}>
        <Typography className={headerTitleClasses}>{title}</Typography>
        <Typography className={headerTextClasses}>{message}</Typography>
      </Grid>
    </Grid>
  );
};

MessageItem.propTypes = {
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
};

export default MessageItem;
